import CategoryAnswer from "../models/answer/categoryAnswer.model";
import {UserCategoryResult} from "../models/userResults/UserCategoryResult.model";
import {plainToInstance} from "class-transformer";
import {UserCategoryResultType} from "../enums/userCategoryResultType.enum";
import Category from "../models/category/category.model";
import {UserProfile} from "../models/userProfile/userProfile.model";
import {CategoryHelper} from "./category.helper";

abstract class MappingProfile {
    static categoryAnswerToUserCategoryAnswer(categoryAnswers: CategoryAnswer[], userProfile?: UserProfile) {
        const resultArray: UserCategoryResult[] = [];

        for (let i = 0; i < categoryAnswers.length; i++) {
            const categoryAnswer = categoryAnswers[i];
            
            let userCategoryResultToUpdateId;
            if(userProfile) {
                for (const userCategoryResult of userProfile.userCategoryResults) {
                    if (categoryAnswer.categoryId == userCategoryResult.categoryId) {
                        userCategoryResultToUpdateId = userCategoryResult.id;
                        break;
                    }
                }
            }
            
            resultArray.push(
                plainToInstance(UserCategoryResult,
                    {
                        id: userCategoryResultToUpdateId,
                        categoryName: categoryAnswer.category?.title ?? "",
                        response: categoryAnswer.label,
                        categoryId: categoryAnswer.categoryId,
                        answerId: categoryAnswer.answerId,
                        type: UserCategoryResultType.Answer
                    }
                )
            );
        }
        return resultArray;
    }
    
    static mapCategoriesOntoCategoryAnswers(categories: Category[], categoryAnswers: CategoryAnswer[]) {
        for (let categoryAnswer of categoryAnswers) {
            if(!categoryAnswer)
            {
                continue;
            }
            categoryAnswer.category = CategoryHelper.findCategoryInCategoryHierarchy(categoryAnswer.categoryId, categories);
        }
    }
}

export { MappingProfile };